import React, { ReactNode } from "react";

import { FormControlLabel, Switch, SwitchProps, useTheme } from "@mui/material";
import { styled } from "@mui/material/styles";

import { IgTypography } from "./IgTypography";
import { IgCustomTheme } from "./theme";

export const StyledSwitch = styled(Switch)(({ theme, size }) => ({}));

type IgSwitchProps = SwitchProps & {
  color?: "primary" | "secondary" | "plugin" | undefined;
  label?: ReactNode;
  labelPlacement?: "top" | "start" | "bottom" | "end" | undefined;
  labelColor?: string | undefined;
};

/**
 * @see Switch
 */
export const IgSwitch = (props: IgSwitchProps) => {
  const theme = useTheme<IgCustomTheme>();
  const defaultProps = theme.components?.MuiSwitch?.defaultProps;
  const {
    disabled,
    onClick,
    color = defaultProps?.color,
    label = null,
    labelPlacement,
    labelColor = null,
    sx,
    ...rest
  } = props;

  const switchElement = (
    <StyledSwitch
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      color={color}
      sx={{
        ml: !label || labelPlacement !== "start" ? 0 : 3,
        mr: !label || labelPlacement === "start" ? 0 : 3,
        ...sx,
      }}
      {...rest}
    />
  );

  return label !== null ? (
    <FormControlLabel
      sx={sx}
      control={switchElement}
      label={
        labelColor ? (
          <IgTypography sx={{ color: labelColor }}> {label} </IgTypography>
        ) : (
          label
        )
      }
      labelPlacement={labelPlacement}
    />
  ) : (
    switchElement
  );
};
